export const OEKO_TEX_API_URL = "https://www.oeko-tex.com/en/detail?number="
